import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { GreekWatermark } from "@/components/GreekWatermark";
import { api } from "@/lib/api";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/blog")
      .then(({ data }) => setPosts(data))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="pt-28 sm:pt-36 pb-20 sm:pb-28 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
      <GreekWatermark letter="Β" className="top-8 right-0" />
      <Reveal>
        <p className="font-accent italic text-gold text-lg mb-3">Journal</p>
        <h1 className="font-anton uppercase tracking-tighter text-cream text-4xl sm:text-6xl">The Elysium Blog</h1>
        <p className="text-smoke mt-4 max-w-lg">Training notes, nutrition guides, and stories from the floor.</p>
      </Reveal>

      {loading ? (
        <div className="flex justify-center py-16">
          <Loader2 className="h-8 w-8 text-gold animate-spin" />
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-14">
          {posts.map((post, i) => (
            <Reveal key={post.id} delay={i * 0.05} className="h-full">
              <Link
                to={`/blog/${post.slug}`}
                className="group block border border-line bg-surface hover:border-gold/50 transition-colors h-full"
                data-testid={`blog-card-${post.slug}`}
              >
                <div className="h-64 overflow-hidden bg-surface">
                  <img
                    src={post.image}
                    alt={post.title}
                    style={post.slug === "why-elysium-exists" ? undefined : { objectPosition: "50% 12%" }}
                    className={`w-full h-full group-hover:scale-105 transition-transform duration-500 ${
                      post.slug === "why-elysium-exists" ? "object-contain" : "object-cover"
                    }`}
                  />
                </div>
                <div className="p-6">
                  <span className="text-xs uppercase tracking-widest text-gold">{post.category}</span>
                  <h3 className="font-anton uppercase text-cream text-lg mt-2 leading-tight">{post.title}</h3>
                  <p className="text-smoke text-sm mt-3 leading-relaxed">{post.excerpt}</p>
                  <p className="text-smoke/60 text-xs mt-4">By {post.author}</p>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      )}
    </div>
  );
}
